<template>
  <div class="profiel pt-12" >
    <v-container fluid class="" py-0 >
      <v-layout row wrap>
        <v-flex xs12 class="" >
          <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? 'px-8' : 'px-2']">
            <v-layout
              fill-height
              row 
              wrap
              :class="[$vuetify.breakpoint.mdAndUp ? 'pt-12 mt-8' : '']"
            >
              <v-flex xs12 md6 lg5 ma-0 class="" :class="[$vuetify.breakpoint.mdAndUp ? 'py-12' : 'py-4']">
                <s-card :title="pageContent.pageSub1">
                  <v-simple-table dense class="mt-8" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-2']">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="pa-3 font-weight-bold" style="width: 50% !important;">Naam</td>
                          <td class="pa-3" style="width: 50% !important;">{{ name }}</td>
                        </tr>
                        <tr>
                          <td class="pa-3 font-weight-bold">Email</td>
                          <td class="pa-3">{{ email }}</td>
                        </tr>
                        <tr v-if="company">
                          <td class="pa-3 font-weight-bold">Bedrijf</td>
                          <td class="pa-3">{{ company }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <form class="">
                    <v-row>
                      <v-col cols="12" class="" :class="[$vuetify.breakpoint.mdAndUp ? 'px-0' : '']">
                        <v-card-text>
                          <v-text-field dark
                            prepend-icon="fas fa-lock"
                            name="password"
                            label="Huidig wachtwoord"
                            id="password_current"
                            v-model="password_current"
                            type="password"
                            :error-messages="errors.current"
                          >
                          </v-text-field>
                          <v-divider dark class="my-4"></v-divider>
                          <v-text-field dark
                            prepend-icon="fas fa-lock"
                            name="password"
                            label="Nieuw wachtwoord"
                            id="password_new"
                            v-model="password_new"
                            type="password"
                            :error-messages="errors.password"
                          >
                          </v-text-field>
                          <v-text-field dark
                            prepend-icon="fas fa-lock"
                            name="password"
                            label="Herhaal nieuw wachtwoord"
                            id="password_repeat"
                            v-model="password_repeat"
                            :error-messages="errors.password_confirmation"
                            type="password"
                          >
                          </v-text-field>
                        </v-card-text>
                        <v-card-actions class="pa-3 ">
                            <v-spacer></v-spacer>
                      <v-btn
                        color="primary" to="" class="text-none"
                        v-html="'Opslaan'"
                        @click="changePassword"
                      >
                      </v-btn>
                      <v-snackbar
                        v-model="snackbar"
                        :timeout="timeout"
                        color="primary"

                      >
                        {{ text }}
                        <v-icon class="white--text">check_circle</v-icon>
                      </v-snackbar>
                        </v-card-actions>
                      </v-col>
                    </v-row>
                  </form>
                </s-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {

  name: 'profiel',
  data() {
    return {
      snackbar: false,
      text: 'Succesvol opgeslagen',
      timeout: 3000,
      pageContent: {
        pageTitle: 'Mijn profiel',
        pageSub1: 'Persoonlijke gegevens',
        pageSub2: 'Wachtwoord wijzigen',
      },
  	  name:'',
  	  email:'',
  	  company:'',
  	  password_current:'',
  	  password_new:'',
  	  password_repeat:'',
  	  errors: {},
    };
  },
  methods: 
  {
	changePassword()
	{
		let data = 
		{
			current: this.password_current,
			password: this.password_new,
			password_confirmation: this.password_repeat,
		}
		
		this.$store.dispatch('changePassword', data).then
		((data) => {
			this.text = data.message;
			this.snackbar = true;
		}).catch((errors) =>
		{
			this.errors = errors.errors;
		});
	}
  },
  watch:
  {
	password_current: {handler () { this.errors.current = undefined; }},
	password_new: {handler () { this.errors.password = undefined; }},
	password_confirmation: {handler () { this.errors.password_confirmation = undefined; }},
  },
  created()
  {
	if(this.$store.getters.auth === false){
		this.$router.push({name: 'authentication'});
		return;
	}
	let self = this;
	this.$store.dispatch('LoadProfile').then
	((data) => {
		this.name = data.name;
		this.email = data.email;
		this.company = data.company;
	});
  },
};
</script>
